import ContentWithBackgroundImage from './ContentWithBackgroundImage'
import useContentWithBackgroundImageProps from './hooks/useContentWithBackgroundImageProps'

export type { ContentWithBackgroundImageProps } from './ContentWithBackgroundImage'
export default ContentWithBackgroundImage

export { ContentWithBackgroundImage, useContentWithBackgroundImageProps }
